import { Capacitor } from '@capacitor/core';
import { InAppReview } from '@capacitor-community/in-app-review';
import ReactDOM from 'react-dom';
import RatingModal from '../components/RatingModal/RatingModal';

/// This Function shows the custom Rating Modal to the user
/// Returns true for "Love it!", false for "Give feedback", and undefined if closed without selection
export default async function showRatingDialog(activateFeedback?: boolean): Promise<boolean | undefined> {
  const isNative = Capacitor.isNativePlatform();

  return new Promise((resolve) => {
    // Create a temporary div element to mount the modal
    const modalContainer = document.createElement('div');
    document.body.appendChild(modalContainer);

    // Function to clean up the modal when done
    let cleaned = false;
    const cleanupModal = () => {
      if (cleaned) return;
      cleaned = true;
      ReactDOM.unmountComponentAtNode(modalContainer);
      if (modalContainer.parentNode) {
        modalContainer.parentNode.removeChild(modalContainer);
      }
    };

    // Handle when user selects "Love it!"
    const handleLoveIt = async () => {
      // Store that the user loved the app
      localStorage.setItem('user_accepted_review', 'true');
      localStorage.setItem('user_accepted_review_date', new Date().toISOString());

      if (isNative) {
        try {
          // Try to show the native app review
          await InAppReview.requestReview();
        } catch (error) {
          console.warn('Error requesting review:', error);
          // Fail silently
        }
      } else {
        console.log('Simulating review request (only available on native devices)');
      }

      cleanupModal();
      resolve(true);
    };

    // Handle when user selects "Give feedback"
    const handleGiveFeedback = () => {
      localStorage.setItem('user_declined_review', 'true');
      localStorage.setItem('user_declined_review_date', new Date().toISOString());

      cleanupModal();
      if (activateFeedback) {
        resolve(false);
      } else {
        console.log('Canceled');
        resolve(undefined);
      }
    };

    // Handle when user closes the modal without making a selection
    const handleClose = () => {
      localStorage.setItem('user_declined_review', 'true');
      localStorage.setItem('user_declined_review_date', new Date().toISOString());
      cleanupModal();
      resolve(undefined);
    };

    // Render the custom modal
    ReactDOM.render(
      <RatingModal
        isOpen={true}
        onClose={handleClose}
        onLoveIt={handleLoveIt}
        onGiveFeedback={handleGiveFeedback}
        disableFeedback={!activateFeedback}
      />,
      modalContainer,
    );
  });
}
